import { MultiSectionLayout, HeaderBreadcrumbs } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";
import { InvoicesTable } from "@jugl-web/domain-resources/invoices/components/InvoicesTable";
import useEntity from "@web-src/modules/entities/hooks/useEntity";
import { InvoicesCreate } from "./components/InvoicesCreate";
import { InvoicesSearch } from "./components/InvoicesSearch";
import { InvoicesItemsPageProvider } from "./context/InvoicesItemsPageProvider";
import { InvoicesHeaderRightContent } from "./components/InvoicesHeaderRightContent";
import { useInvoicesItemsPage } from "./context/useInvoicesItemsPage";
import { InvoicesFilters } from "./components/InvoicesFilters";
import { useUpdateInvoice } from "../../hooks/useUpdateInvoice";
import { useInvoicesConfigList } from "../InvoicesSettingsPage/pages/InvoicesBusinessInformationPage/hooks/useInvoicesConfigList";
import { useChangeInvoiceType } from "../../hooks/useChangeInvoiceType";

const InvoicesItemsPageContent = () => {
  const { t } = useTranslations();
  const { navigateToPage } = useNavigation();
  const { entity } = useEntity();
  const { searchQuery, filters } = useInvoicesItemsPage();
  const changeInvoiceType = useChangeInvoiceType();
  const updateInvoice = useUpdateInvoice();
  const { data: configData } = useInvoicesConfigList();
  const config = configData?.data?.[0];

  return (
    <MultiSectionLayout
      header={
        <>
          <HeaderBreadcrumbs
            items={[
              {
                title: t({
                  id: "invoices-items-page.invoices",
                  defaultMessage: "Invoices",
                }),
                onClick: () => navigateToPage("invoices"),
              },
            ]}
            rightContent={<InvoicesHeaderRightContent />}
          />

          <div className="flex items-center justify-between bg-[#EEF2F5] px-8 py-4">
            <div className="flex items-center gap-6">
              <InvoicesSearch />
              <InvoicesFilters />
            </div>
            <InvoicesCreate />
          </div>
        </>
      }
      classNames={{
        content: "p-8",
      }}
    >
      <InvoicesTable
        variant="all"
        entity={{ id: entity?.id || "", name: entity?.name || "" }}
        config={config}
        searchQuery={searchQuery}
        filters={filters}
        actions={{
          changeInvoiceType,
          updateInvoice,
        }}
        onNavigate={(str, type) => {
          if (type?.type) {
            navigateToPage(str, {
              type: type.type,
            });
          } else if (type?.id) {
            navigateToPage(str, {
              id: type.id,
            });
          } else {
            navigateToPage(str, {
              type: "invoice",
            });
          }
        }}
      />
    </MultiSectionLayout>
  );
};

export const InvoicesItemsPage = () => (
  <InvoicesItemsPageProvider>
    <InvoicesItemsPageContent />
  </InvoicesItemsPageProvider>
);
